import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import './Location.css';

const Spinner = () => (
    <div className="inline-block w-5 h-5 border-3 border-gray-300 border-t-blue-600 rounded-full animate-spin mr-2"></div>
);

const defaultLocation = {
    latitude: '0.000000',
    longitude: '0.000000',
    accuracy: 0,
    timestamp: new Date().toLocaleString(),
};

const LocationPermissionComponent = ({ setcustomerLocationDetails }) => {
    const [status, setStatus] = useState({ message: '', type: '', loading: false });

    const showStatus = (message, type = 'info', loading = false) => {
        setStatus({ message, type, loading });
    };

    const showLocationDetails = async (position) => {
        const { latitude, longitude, accuracy } = position.coords;
        const timestamp = new Date(position.timestamp).toLocaleString();

        const locationInfo = {
            latitude: latitude.toFixed(6),
            longitude: longitude.toFixed(6),
            accuracy: Math.round(accuracy),
            timestamp,
        };

        try {
            setcustomerLocationDetails(locationInfo);
            toast.success('Location access granted successfully!');
        } catch (error) {
            console.error('Error setting location details:', error);
            setcustomerLocationDetails(defaultLocation);
        }
    };

    const requestLocation = () => {
        showStatus('Requesting location access...', 'loading', true);

        const options = {
            enableHighAccuracy: true,
            timeout: 15000,
            maximumAge: 300000,
        };

        navigator.geolocation.getCurrentPosition(
            (position) => {
                showLocationDetails(position);
                setStatus({ message: '', type: '', loading: false });
            },
            () => {
                setcustomerLocationDetails(defaultLocation);
                setStatus({ message: '', type: '', loading: false });
            },
            options
        );
    };

    useEffect(() => {
        if (!navigator.geolocation) {
            setcustomerLocationDetails(defaultLocation);
            return;
        }
        requestLocation();
    }, []);

    return null;
};

const Location = ({ setCustomerLocationDetails }) => {
    return (
        <LocationPermissionComponent setcustomerLocationDetails={setCustomerLocationDetails} />
    );
};

Location.propTypes = {
    setCustomerLocationDetails: PropTypes.func,
};

LocationPermissionComponent.propTypes = {
    setcustomerLocationDetails: PropTypes.func.isRequired,
};

export default Location;